import { getSTS, verifyToken } from '../api/auth';

const TOKEN_KEY = 'cos_auth_token';
const USER_KEY = 'cos_user_info';
const STS_KEY = 'cos_sts_credentials';

// 获取 Token
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

// 设置 Token
export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

// 清除登录信息
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(STS_KEY);
};

// 获取用户信息
export const getUserInfo = () => {
  const info = localStorage.getItem(USER_KEY);
  return info ? JSON.parse(info) : null;
};

// 设置用户信息
export const setUserInfo = (info) => {
  localStorage.setItem(USER_KEY, JSON.stringify(info));
};

// 检查是否已登录
export const isLoggedIn = async () => {
  const token = getToken();
  if (!token) return false;

  try {
    const result = await verifyToken(token);
    return result.valid;
  } catch (error) {
    return false;
  }
};

// 获取临时密钥（带缓存）
export const getCredentials = async () => {
  const token = getToken();
  if (!token) {
    throw new Error('未登录');
  }

  // 检查缓存
  const cached = localStorage.getItem(STS_KEY);
  if (cached) {
    const credentials = JSON.parse(cached);
    // 提前 5 分钟刷新
    if (credentials.expiredTime > (Date.now() / 1000) + 300) {
      return credentials;
    }
  }

  // 获取新的临时密钥
  const result = await getSTS(token);
  if (!result.success) {
    if (result.error?.includes('Token')) {
      clearAuth();
      window.location.reload();
    }
    throw new Error(result.error || '获取临时密钥失败');
  }

  // 缓存密钥
  localStorage.setItem(STS_KEY, JSON.stringify(result.data));
  return result.data;
};

// 初始化 COS 实例
export const initCOS = async () => {
  const COS = (await import('cos-js-sdk-v5')).default;
  const credentials = await getCredentials();

  return {
    cos: new COS({
      getAuthorization: (options, callback) => {
        callback({
          TmpSecretId: credentials.tmpSecretId || credentials.TmpSecretId,
          TmpSecretKey: credentials.tmpSecretKey || credentials.TmpSecretKey,
          SecurityToken: credentials.sessionToken || credentials.Token,
          ExpiredTime: credentials.expiredTime || credentials.ExpiredTime
        });
      }
    }),
    bucket: credentials.bucket,
    region: credentials.region,
    permissions: credentials.permissions
  };
};
